// Tasteful scroll-reveal: fade/slide elements in as they enter the viewport.
// Progressive enhancement — if JS or IntersectionObserver is unavailable, or the
// visitor prefers reduced motion, everything is shown immediately (no hidden content).
(function () {
  var els = Array.prototype.slice.call(document.querySelectorAll(".reveal"));
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce || !("IntersectionObserver" in window)) {
    els.forEach(function (el) { el.classList.add("in"); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
  els.forEach(function (el) { io.observe(el); });
})();

// Mobile nav: hamburger toggle for the off-canvas link/CTA panel. Vanilla JS,
// progressive enhancement — without JS the toggle button is inert and the
// panel (default `hidden`) never appears; nothing is lost, nothing breaks.
(function () {
  var toggle = document.querySelector(".nav-toggle");
  var panel = document.getElementById("mobile-nav");
  if (!toggle || !panel) return;

  function closeMenu() {
    panel.hidden = true;
    toggle.setAttribute("aria-expanded", "false");
  }
  function openMenu() {
    panel.hidden = false;
    toggle.setAttribute("aria-expanded", "true");
  }

  toggle.addEventListener("click", function () {
    if (panel.hidden) { openMenu(); } else { closeMenu(); }
  });

  // Close after tapping any link inside the panel (in-page anchors like
  // #how / #reviews don't reload, so the panel would otherwise stay open).
  panel.addEventListener("click", function (e) {
    if (e.target.tagName === "A") { closeMenu(); }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !panel.hidden) { closeMenu(); toggle.focus(); }
  });

  document.addEventListener("click", function (e) {
    if (!panel.hidden && !panel.contains(e.target) && !toggle.contains(e.target)) {
      closeMenu();
    }
  });
})();
